import React from "react";

import { TaglineMSpan } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";

import * as S from "./styles";

const ButtonAddNew = ({ children, ...props }) => {
  return (
    <S.Container {...props}>
      {children || (
        <TaglineMSpan
          color={
            props?.disabled
              ? theme.colors.disabled.Desabilitado_Medio
              : theme.colors.blue.Azul_link
          }
        >
          Adicionar <br />novo
        </TaglineMSpan>
      )}
    </S.Container>
  );
};

export default ButtonAddNew;
